import Vue from 'vue';
import Accordion from '../../common/components/accordion/accordion.vue';
import AccordionItem from '../../common/components/accordion-item/accordion-item.vue';
Vue.component('accordion', Accordion);
Vue.component('accordion-item', AccordionItem);

export default {
	data() {
		return {
			anyAccordionItemClicked: false,
			accordionsOpen: []
		};
	},
	props: ['ga_category', 'ga_action', 'accordionsOpenProp'],
	components: {
		Accordion,
		AccordionItem
	},
	methods: {
		accordionItemClicked() {
			this.anyAccordionItemClicked = true;
		}
	},
	created() {
		// az accordion lib képtelen kezelni azt az esetet, hogy több accordion legyen egyzsrre lenyitva
		// és összevissza indokolatlan működést eredményez
		let index = this.accordionsOpenProp.lastIndexOf(true);
		this.accordionsOpen.map(()=>{
			return false;
		});
		if (index > -1) {
			this.accordionsOpen[index] =  true;
		}
	}
};
